import { Button, Result } from "antd";
import { Link, useNavigate } from "react-router-dom";

const Unauthorized = () => {
    const navigate = useNavigate();
  
    const handleGoBack = () => {
      navigate(-1); // This takes the user to the previous page
    };
  
    return (
        <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={<Link to={"/dashboard"}><Button type="primary">Back Home</Button></Link>}
      />
    );
  };
  
  const styles = {
    container: {
        // display: 'flex',
        // flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f8f8f8',
    },
    heading: {
      fontSize: '2.5rem',
      marginBottom: '1rem',
      color: '#333',
    },
    text: {
      fontSize: '1.2rem',
      marginBottom: '2rem',
      color: '#555',
    },
    button: {
      padding: '0.75rem 1.5rem',
      fontSize: '1rem',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
  };
  
  export default Unauthorized;